export const menu = [
  {
    id: 1,
    title: 'home',
    icon: 'lucide:home',
    url: '/home',
  },
  {
    id: 2,
    title: 'list',
    icon: 'lucide:layout-grid',
    url: '/assets',
  },
  {
    id: 3,
    title: 'assets',
    icon: 'lucide:user',
    url: '/owned',
  },
  {
    id: 4,
    title: 'faq',
    icon: 'lucide:info',
    url: '/faq',
  },
];